import React from "react";
import { Button } from "./ui/button";
import { Facebook, Instagram } from "lucide-react";

const FloatingSocialMedia = () => {
  const socialLinks = [
    {
      name: "Facebook",
      url: "https://www.facebook.com/umoona",
      icon: Facebook,
      color: "bg-blue-600 hover:bg-blue-700",
      textColor: "text-blue-600"
    },
    {
      name: "Instagram", 
      url: "https://www.instagram.com/umoonaopal",
      icon: Instagram,
      color: "bg-gradient-to-br from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700",
      textColor: "text-purple-600"
    }
  ];

  return (
    <div className="fixed bottom-6 left-6 z-50 flex flex-col space-y-3">
      {socialLinks.map((social) => {
        const IconComponent = social.icon;
        return (
          <div key={social.name} className="group relative">
            <Button
              asChild
              size="lg"
              className={`${social.color} text-white shadow-xl hover:shadow-2xl hover:scale-110 transition-all duration-300 w-14 h-14 rounded-full p-0`}
            >
              <a
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Follow us on ${social.name}`}
              >
                <IconComponent className="w-6 h-6" />
              </a>
            </Button>
            
            {/* Tooltip */}
            <div className="absolute left-16 top-1/2 transform -translate-y-1/2 bg-gray-900 text-white px-3 py-2 rounded-lg text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap shadow-lg">
              Follow us on {social.name}
              <div className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-1 w-2 h-2 bg-gray-900 rotate-45"></div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FloatingSocialMedia;